import { SVMChain } from '../../types';
import { CAI_MINT, Consts, fetchGlobalState, getListedNfts as getListedSVMNfts, getMyNfts as getMySVMNfts, getSolBalance, getTokenBalance, isSvmProgramInitialized, } from '../../chains/svm/api';
import { translateErrorMessage } from '../../utils/common';
export function isSvmChainReady() {
    return isSvmProgramInitialized();
}
export async function updateSVMGlobalState(chain, deps, getChainStateFn, patchChainStateFn) {
    const gl = await fetchGlobalState()
        .then((globalState) => ({
        ...globalState,
        mintPrice: Number(globalState?.presalePrice ?? 0) / Consts.defaultDenominator,
    }))
        .catch((e) => {
        deps.toast.error(`${chain}:${translateErrorMessage(e)}`);
        return null;
    });
    deps.setState((prev) => {
        const chainState = getChainStateFn(prev, chain);
        return patchChainStateFn(prev, chain, {
            global: gl,
            isStable: chainState.weiBalance != null && gl != null,
            isMarketOpened: !gl?.paused,
        });
    });
}
export async function updateSVMUserState(chain, deps, getChainStateFn, patchChainStateFn) {
    let balance = 0;
    let weiBalance = undefined;
    if (deps.svmWallet.publicKey) {
        weiBalance = await getSolBalance(deps.svmWallet.publicKey).catch(() => undefined);
        if (chain === SVMChain.Solana) {
            balance = await getTokenBalance(deps.svmWallet.publicKey, CAI_MINT)
                .then((res) => res.value.uiAmount ?? 0)
                .catch(() => 0);
        }
    }
    deps.setBalances((prev) => ({
        ...prev,
        [chain]: weiBalance,
    }));
    deps.setState((prev) => {
        const chainState = getChainStateFn(prev, chain);
        return patchChainStateFn(prev, chain, {
            balance,
            weiBalance,
            isStable: weiBalance != null && chainState.global != null,
            walletAddress: deps.svmWallet?.publicKey?.toString() ?? null,
        });
    });
}
export async function fetchSvmListedNfts(allListedNfts) {
    return getListedSVMNfts(allListedNfts, null);
}
export async function fetchSvmMyNfts(myNfts) {
    return getMySVMNfts(myNfts);
}
